export function fadeIn(el: Element, duration = 300) {
  el instanceof HTMLElement && (el.style.transition = `opacity ${duration}ms`);
  el instanceof HTMLElement && (el.style.opacity = '1');
}

document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('[data-fade]');
  targets.forEach((el) => fadeIn(el, 300));
});
